import type { FC } from "react";
import Button from "../UI/Button";
import { useTranslation } from "@/i18n";
import styles from "./ExitModal.module.css";

interface ExitModalProps {
  title?: string;
  description?: string;
  exitConfirmText?: string;
  exitCancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ExitModal: FC<ExitModalProps> = ({
  onConfirm,
  onCancel,
  title,
  description,
  exitConfirmText,
  exitCancelText,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h3 className={styles.title}>{title || t("modal.exit.title")}</h3>
        <p className={styles.description}>
          {description || t("modal.exit.description")}
        </p>
      </div>
      <div className={styles.actions}>
        <Button onClick={onConfirm} variant="primary" className={styles.button}>
          {exitConfirmText || t("modal.exit.confirm")}
        </Button>
        <Button
          onClick={onCancel}
          variant="secondary"
          className={styles.button}
        >
          {exitCancelText || t("modal.exit.cancel")}
        </Button>
      </div>
    </div>
  );
};
